/**
 * @file Builds the map of every joint profile field as a hidden input.
 */
import { TYPE_NONE } from "@components/Form";

import type { Input } from "../types";

const FIELD_NAMES = [
  "isLiabilityAccepted",
  "hasPurchasedExemptSecurities",
  "membershipInterestsTitle",
  "hasJointTaxReturn",
  "shouldCoInvestorSign",
  "jointGivenName",
  "jointAdditionalName",
  "jointFamilyName",
  "jointEmail",
  "jointAddress",
  "isUsCitizen",
  "isUsPerson",
  "hasOtherUsResidenceState",
  "residenceState",
  "hasSsn",
  "ssnNumber",
];

/**
 * Returns every joint profile field as a hidden input, keyed by the
 * field name.
 */
const getProfileJointInputsMap = (): Record<string, Input> => {
  const inputsMap: Record<string, Input> = {};

  for (const name of FIELD_NAMES) {
    inputsMap[name] = { name, type: TYPE_NONE };
  }

  return inputsMap;
};

export default getProfileJointInputsMap;
